export default __webpack_public_path__ + "static/media/people.9eae4d44.webp";